import React from 'react';
import styled from 'styled-components';

const CashflowNotRequiredContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const CashflowNotRequired = () => (
  <CashflowNotRequiredContainer>
    <h3>Additional cash flow analysis is not required for this product</h3>
  </CashflowNotRequiredContainer>
);

export default CashflowNotRequired;
